// Scroll-reveal + sticky-nav shading, replacing the theme's Waypoints/jQuery.
//
// `.js` on <html> gates the reveal transition in CSS, so the prerendered HTML
// stays fully visible when JavaScript is unavailable.
export function initSiteMotion() {
  const root = document.documentElement;
  root.classList.add('js');

  const nav = document.querySelector('.nav');
  const onScroll = () => {
    if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const reveal = (el) => el.classList.add('is-visible');
  const cleanups = [() => window.removeEventListener('scroll', onScroll)];

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(reveal);
    return () => cleanups.forEach((fn) => fn());
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        // Stagger siblings slightly so a grid reveals as a wave, not a block.
        const index = Number(entry.target.dataset.revealIndex || 0);
        entry.target.style.transitionDelay = `${Math.min(index, 6) * 70}ms`;
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 },
  );

  const observe = (el) => {
    if (!el.classList.contains('is-visible')) observer.observe(el);
  };

  document.querySelectorAll('.reveal').forEach(observe);
  cleanups.push(() => observer.disconnect());

  // React adds .reveal elements after mount - the gallery's "load more" button
  // is the obvious case. Without this they would keep the CSS opacity:0 start
  // state forever and render as blank space, so watch for new nodes.
  if ('MutationObserver' in window) {
    const mutations = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('reveal')) observe(node);
          node.querySelectorAll?.('.reveal').forEach(observe);
        }
      }
    });
    mutations.observe(document.body, { childList: true, subtree: true });
    cleanups.push(() => mutations.disconnect());
  }

  return () => cleanups.forEach((fn) => fn());
}
